/**
 * @module Services/UserPreferencesApiService
 * @desc UserPreferencesApiService
 */

import { throwError } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import querystring from 'querystring';

import { ENDPOINT_URL } from './constants';

export class BaseApiService {
  static get(url, addAuth, responseType = 'json', withToken) {
    return BaseApiService.ajax(
      'GET',
      url,
      responseType,
      undefined,
      undefined,
      ENDPOINT_URL,
      addAuth,
      withToken
    );
  }

  static put(
    url,
    body,
    headers = { 'Content-Type': 'application/json; charset=utf-8' },
    addAuth,
    responseType = 'json',
    withToken
  ) {
    return BaseApiService.ajax(
      'PUT',
      url,
      responseType,
      body,
      {
        ...headers,
      },
      ENDPOINT_URL,
      addAuth,
      withToken
    );
  }

  static delete(
    url,
    body,
    headers = { 'Content-Type': 'application/json; charset=utf-8' },
    addAuth,
    responseType = 'json',
    withToken
  ) {
    return BaseApiService.ajax(
      'DELETE',
      url,
      responseType,
      body,
      headers,
      ENDPOINT_URL,
      addAuth,
      withToken
    );
  }

  static post(
    url,
    body,
    headers = { 'Content-Type': 'application/x-www-form-urlencoded' },
    addAuth,
    responseType = 'json',
    withToken
  ) {
    return BaseApiService.ajax(
      'POST',
      url,
      responseType,
      querystring.stringify(body),
      {
        ...headers,
      },
      ENDPOINT_URL,
      addAuth,
      withToken
    );
  }

  static ajax(
    method,
    url,
    responseType,
    body,
    headers = { 'Content-Type': 'application/json; charset=utf-8' },
    endpointUrl,
    addAuth = true,
    withToken = true
  ) {
    return ajax({
      url: `${endpointUrl}${url}`,
      method,
      withCredentials: true,
      responseType,
      headers,
      body,
      crossDomain: true,
    });
  }

  static getErrorHandler(
    className: string,
    methodName: string,
    redirectOverride:
      | boolean
      | Array
      | {
          statusCodes: Array,
          message?: string,
          redirect?: string,
          preventActions?: boolean,
        }
  ) {
    return error => {
      let actions = [
        // showErrorSystemNotification({
        //   message:
        //     "Oops! That didnt work. For help, email <a href='mailto:support@huzzah.com'>support@huzzah.com</a>."
        // })
      ];

      // switch (error.status) {
      //   case HTTP_STATUS_CODE.UNAUTHORIZED: {
      //     actions = [wipeUserData()];
      //     break;
      //   }
      //   case HTTP_STATUS_CODE.FORBIDDEN: {
      //     actions = [
      //       showErrorSystemNotification({
      //         message:
      //           'Raise your hand if you need extra permissions to see this page!  For help, email <a href="mailto:support@huzzah.com">support@huzzah.com</a>.'
      //       })
      //     ];
      //     break;
      //   }
      //   case HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR: {
      //     actions = [
      //       showErrorSystemNotification({
      //         message:
      //           "Yikes, something went kaboom on our end. For help, email <a href='mailto:support@huzzah.com'>support@huzzah.com</a>."
      //       })
      //     ];
      //     break;
      //   }
      //   case HTTP_STATUS_CODE.NOT_FOUND:
      //   case HTTP_STATUS_CODE.BAD_REQUEST:
      //   case HTTP_STATUS_CODE.BAD_GATEWAY: {
      //     actions = [
      //       showErrorSystemNotification({
      //         message:
      //           "Whoops! We can't find that.  For help, email <a href='mailto:support@huzzah.com'>support@huzzah.com</a>."
      //       })
      //     ];
      //     break;
      //   }
      //   case HTTP_STATUS_CODE.SESSION_EXPIRED: {
      //     actions = [wipeUserData()];
      //     break;
      //   }
      //   default:
      //     break;
      // }

      /* eslint-disable no-console */
      console.error(className, methodName, redirectOverride, error);
      /* eslint-enable no-console */

      return throwError({
        error,
        actions,
      });
    };
  }
}
